module.exports = __webpack_public_path__ + "img/ebconlaptop.19611553.png";